<div class="page-layout-container">
  <form [formGroup]="monthlyForm">
    <div class="row">
      <div class="col-6" style="padding: 20px 0 0 20px;width: 80%; margin-right: 30px">
        <app-emp-name [filterEmpName]="filterEmpName" (empName)="empNameSelected($event)" formControlName="name">
        </app-emp-name>
      </div>
      <div class="col">
        <button mat-button (click)="getMonthlyTimesheet(date)"  button>
          Fetch Month Leaves
        </button>

      </div>
    </div>
  </form>

  <!--*ngIf="employeeData !== null" -->
  <div id="monthlyTimesheet" *ngIf="employeeData !== null" class="main-container">
    <div class="row">
      <div class="col-2" style="color:#4a148c;font-family: Helvetica, Arial, sans-serif;font-size: 1rem;">
        Working Days = {{numberOfWorkingDays}}
      </div>
      <div class="col-2" style="color:#4a148c;font-family: Helvetica, Arial, sans-serif;font-size: 1rem;">
        Leaves = {{numberOfLeaves}}
      </div>
      <div class="col-2" style="color:#4a148c;font-family: Helvetica, Arial, sans-serif;font-size: 1rem;">
        Days worked = {{numberOfDaysWorked}}
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="flex-container flex-center" style="margin: 20px 0 40px 0">
          <button (click)="previousMonth()" class="iconsSize ml-1 my-auto" mat-icon-button>
            <mat-icon>
              chevron_left
            </mat-icon>
          </button>
          <button (click)="nextMonth()" class="iconsSize ml-1 my-auto" mat-icon-button>
            <mat-icon>
              chevron_right
            </mat-icon>
          </button>
          <h5 class="icon-font">{{date.format('MMMM ')}}{{date.format('YYYY ')}}</h5>
        </div>
        <div *ngFor="let calendarItem of calendar; let i = index">
          <div class="flex-container">
            <div *ngFor="let day of calendarItem" [class.weekend]="day.isWeekend" [ngClass]="day.className"
              class="calendar-days position-relative">
              <div *ngIf="i === 0" class="weekday-title">{{day.dayName}}</div>
              <p class="leaveList">{{day.day}}<br>
                {{day.employeeData}}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 m-auto" style="padding-left: 100px">
        <div *ngFor="let leave of leaveList" class="d-flex">
          <div [ngClass]="leave.className" class="square"></div>
          <p class="pl-10 leaveList">{{leave.name}}</p>
          <!-- <p class="pl-10 leaveList">{{leave.value}}</p> -->
        </div>
      </div>
    </div>
  </div>

  <app-progress [loading$]="loading$"> </app-progress>
</div>
